import { render, staticRenderFns } from "./UndeliveredDispatchesToAddToRouteList.vue?vue&type=template&id=bca84f66&scoped=true&"
import script from "./UndeliveredDispatchesToAddToRouteList.vue?vue&type=script&lang=js&"
export * from "./UndeliveredDispatchesToAddToRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca84f66",
  null
  
)

export default component.exports